import { render } from "./ios-radio-button-off.vue?vue&type=template&id=5d956fec"
import script from "./ios-radio-button-off.vue?vue&type=script&lang=js"
export * from "./ios-radio-button-off.vue?vue&type=script&lang=js"
script.render = render

export default script